/**This component comes into action upon clicking edit button on Donate section of registered user */

import {
	AfterViewInit,
	Component,
	OnInit,
	Input,
	HostListener,
	ChangeDetectorRef,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { ProfileService } from 'src/app/pages/user/profile/services/profile.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DonationService } from 'src/app/pages/donation/services/donation.service';
import { Location, NgIf, NgFor, NgClass } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { DeleteWidgetStyleComponent } from '../../dialogs/delete-widget-style/delete-widget-style';
import { timer } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Tools } from 'src/utilities/tools';
import { environment } from 'src/environments/environment';
import { PageLoaderComponent } from '../../../../../shared/components/page-loader/page-loader.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'fundraiser-widget-edit.html',
    templateUrl: './fundraiser-widget-edit.html',
    standalone: true,
    imports: [MatButtonModule, MatCardModule, FlexModule, NgIf, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, MatSlideToggleModule, FormsModule, MatCheckboxModule, MatButtonToggleModule, MatInputModule, MatExpansionModule, MatIconModule, ExtendedModule, NgClass, MatTooltipModule, PageLoaderComponent]
})
/** *Custom Donation Form Component */
export class fundraiserWidgetEditComponent implements OnInit, AfterViewInit {
	matTooltip = $localize`:@@share_fundraiser_tooltip_copy_code: Copy the code`;
	buttonStates: { [key: string]: boolean } = {};

	donation_box: SafeHtml | undefined;
	donation_window_modal: SafeHtml | undefined;
	shortcode: any = 0;
	id: any = 'id';
	selectedInterval: any = '';
	fundraiser_list: any[] = [];
	style_data: any = {};
	oneTimeCheck: any = '';
	monthlyCheck: any = '';
	yearlyCheck: any = '';
	targetAmountByCurrency: any = '';
	currencyCode: any = '';
	currencySymbol: any = '€';
	currencyMaxAmount: any = '';
	currencyMinAmount: any = '';
	disabled: boolean = false;
	isLoading: boolean = true;
	previewBoxShadowNumber: number = 1;

	showDonateButton: number = 1;
	showProgressBar: number = 2;
	showRaisedAmount: number = 3;
	showEndDate: number = 4;
	doNotShowBox: number = 0;
	generatedWidgetHTML: string = '';
	createFundraiserSelection = $localize`:@@widget_form_create_fundraiser_widget:Please Select Fundraiser`;
	defaultFundraiser: any = {
		title: this.createFundraiserSelection,
		slug: '',
		id: '',
		currency_code: 'eur',
	};
	lang: any = this._accountService.getLocaleId();
	@Input() showDonationFormOnlyChecked: boolean = false;
	@Input() showMainImageChecked: boolean = true;

	@Input() valueChangeFirstAmount: number = 50;
	@Input() valueChangeSecondAmount: number = 100;
	@Input() valueChangeThirdAmount: number = 250;
	@Input() valueChangeFourthAmount: number = 500;
	@Input() valueChangeFifthAmount: number = 0;
	// create 1000

	@Input() valueChangeFirstAmountMonthly: number = 5;
	@Input() valueChangeSecondAmountMonthly: number = 10;
	@Input() valueChangeThirdAmountMonthly: number = 25;
	@Input() valueChangeFourthAmountMonthly: number = 50;
	@Input() valueChangeFifthAmountMonthly: number = 0;
	// create 100

	@Input() valueChangeFirstAmountYearly: number = 50;
	@Input() valueChangeSecondAmountYearly: number = 100;
	@Input() valueChangeThirdAmountYearly: number = 250;
	@Input() valueChangeFourthAmountYearly: number = 500;
	@Input() valueChangeFifthAmountYearly: number = 0;
	// create 1000

	@Input() showAmountOtherChecked: boolean = false;

	@Input() showHideOneTimeChecked: boolean = true;
	@Input() showHideMonthlyChecked: boolean = true;
	@Input() showHideYearlyChecked: boolean = true;

	@Input() onetimeOpenAmountChecked: boolean = false;
	@Input() monthlyOpenAmountChecked: boolean = false;
	@Input() yearlyOpenAmountChecked: boolean = false;

	@Input() currentPrimaryColor: string = '#32BF55';
	@Input() currentSecondaryColor: string = '#363396';
	@Input() boxShadowNumber: number = 1;

	@Input() currentButtonRadius: any = 30;
	@Input() valuechangeDonationLabel: any = 'My Safe Donation';
	@Input() selectedFundraiser: any = -1;

	@Input() widgetFontName: string = 'Roboto';

	@Input() showDonateCard: boolean = true;
	scriptUrl: any;
	cssUrl: any;
	show_donation_details: string | undefined | boolean;
	amount_target: number = 0;
	end_date: string | undefined;

	fundraiserSuccessUrl: string = '';
	fundraiserFailUrl: string = '';
	selectFundraiserCreate: Number = 0;
	api_key = '';
	screenWidth: number = 0;
	cssUrlPage: any;
	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.screenWidth = window.innerWidth;
	}

	/**
	 * Constructor
	 */
	/**
	 * Constructor
	 */
	constructor(
		private _profileService: ProfileService,
		public fundraiserService: FundraiserService,
		public _accountService: AccountService,
		private route: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private router: Router,
		public donationService: DonationService,
		private notificationService: NotificationService,
		private cdr: ChangeDetectorRef
	) {
		// this.scriptUrl = 'http://localhost:4200/assets/wp_styling_development.js';
		// this.cssUrlPage = this.sanitizer.bypassSecurityTrustResourceUrl(
		// 		'https://plugin.whydonate.com/wdplugin-style-development.css'
		// 	);
			// this.cssUrl =
			// 	'https://plugin.whydonate.com/wdplugin-style-development.css';

		if (environment.production == true) {
			this.scriptUrl = 'https://plugin.whydonate.com/wp_styling.js';
			this.cssUrlPage = this.sanitizer.bypassSecurityTrustResourceUrl(
				'https://plugin.whydonate.com/wdplugin-style.css'
			);
			this.cssUrl = 'https://plugin.whydonate.com/wdplugin-style.css';
		} else {
			this.scriptUrl = 'https://plugin.whydonate.com/wp_styling_development.js';
			this.cssUrlPage = this.sanitizer.bypassSecurityTrustResourceUrl(
				'https://plugin.whydonate.com/wdplugin-style-development.css'
			);
			this.cssUrl =
				'https://plugin.whydonate.com/wdplugin-style-development.css';
		}
		// console.log(this.scriptUrl)
	}

	ngOnInit(): void {
		Tools.setPreviousPath('');

		// const scriptUrl: string = 'http://localhost:4200/assets/wp_styling.js';
		// Access the route parameters
		this.route.params.subscribe((params) => {
			this.shortcode = params['shortcode'];
		});

		// let api_key: string;
		let self = this; //To access inside jquery as this. is not working

		this.loadScript(this.scriptUrl).then(() => {
			this._profileService.getApiKey().subscribe((res: any) => {
				if (res && res.data.response == 'ApiKeyNotAvailable') {
					this.api_key = '';
				} else {
					this.api_key = res.data.data.api_key;
				}

				this.fundraiserService
					.getUserFundraiserListByApiKey(this.api_key)
					.subscribe((res: any) => {
						if (!Array.isArray(res.data)) {
							res.data = [];
						}
						if (this.shortcode == 'create') {
							this.valueChangeFifthAmount = 1000;
							this.valueChangeFifthAmountMonthly = 100;
							this.valueChangeFifthAmountYearly = 1000;
							
							if (res.data.length == 0) {
								this.router.navigate([`/fundraising/widget`]);
							}
						}
					});

				this.fundraiserService
					.getWidgetStyleByShortcode(this.shortcode)
					.subscribe(async (res: any) => {
						let html_json;
						if (res?.data?.message != 'Not_Avaliable') {
							this.id = `${res.data.id}_def`;
							this.style_data = res.data;
							html_json = await this.callpreview_html_generator(res.data);
						} else {
							this.id = this.shortcode;
							this.style_data = res.data;
							html_json = await this.callpreview_html_generator({
								// id: this.id + '_def',
								id: this.id,
							});
							this.id = this.id + '_def'
						}

						this.donation_box = this.sanitizer.bypassSecurityTrustHtml(
							this.sanitizeHTML(html_json.donation_box)
						);
						this.donation_window_modal = this.sanitizer.bypassSecurityTrustHtml(
							this.sanitizeHTML(html_json.donation_window_modal)
						);

						this.fundraiserService
							.getUserFundraiserListByApiKey(this.api_key)
							.subscribe((res: any) => {
								if (!Array.isArray(res.data)) {
									res.data = [];
								}
								if (this.shortcode == 'create') {
									this.fundraiser_list = [this.defaultFundraiser, ...res.data];
								} else {
									this.fundraiser_list = res.data;
								}

								// To set values on first render
								if (!('message' in this.style_data)) {
									if (this.style_data.oneTimeCheck != 0) {
										this.selectedInterval = 'once';
									} else if (
										this.style_data.oneTimeCheck == 0 &&
										this.style_data.monthlyCheck != 0
									) {
										this.selectedInterval = 'monthly';
									} else if (
										this.style_data.oneTimeCheck == 0 &&
										this.style_data.monthlyCheck == 0 &&
										this.style_data.yearlyCheck != 0
									) {
										this.selectedInterval = 'yearly';
									}

									const fundraiser_list_selected_index =
										this.fundraiser_list.findIndex(
											(fundraiser) =>
												fundraiser.slug == this.style_data.slugName
										);

									if (fundraiser_list_selected_index !== -1) {
										this.selectedFundraiser = fundraiser_list_selected_index;
									}

									if (this.fundraiser_list && this.selectedFundraiser) {
										this.currencyCode =
											this.fundraiser_list[
												this.selectedFundraiser
											].currency_code;
									}

									this.fundraiserSuccessUrl = this.style_data.successUrl;
									this.fundraiserFailUrl = this.style_data.failureUrl;
									this.getCurrencyDetailsAndRender();
								} else {
									if (this.style_data.oneTimeCheck != 0) {
										this.selectedInterval = 'once';
									} else if (
										this.style_data.oneTimeCheck == 0 &&
										this.style_data.monthlyCheck != 0
									) {
										this.selectedInterval = 'monthly';
									} else if (
										this.style_data.oneTimeCheck == 0 &&
										this.style_data.monthlyCheck == 0 &&
										this.style_data.yearlyCheck != 0
									) {
										this.selectedInterval = 'yearly';
									}

									const fundraiser_list_selected_index =
										this.fundraiser_list.findIndex(
											(fundraiser) =>
												fundraiser.slug == this.style_data.slugName
										);

									if (fundraiser_list_selected_index !== -1) {
										this.selectedFundraiser = fundraiser_list_selected_index;
									} else {
										this.selectedFundraiser = 0;
									}

									this.getCurrencyDetailsAndRenderDefault();
								}
								// Select all elements with the class '.mat-expansion-panel-body'
								let styleElements = document.querySelectorAll(
									'.mat-expansion-panel-body'
								) as NodeListOf<HTMLElement>;

								// Convert NodeListOf to an array and iterate over the elements to apply the styling
								Array.from(styleElements).forEach((element: HTMLElement) => {
									element.style.paddingLeft = '0';
									element.style.paddingRight = '0';
								});

								this.generatedWidgetHTML = this.generateWidgetHTML(
									this.shortcode
								);
							});
					});
			});
		});

		// Add an event listener to the body for delegation
		document.body.addEventListener('change', function (event) {
			var target = event.target;

			// let appearancePreviewCardShortcode = <HTMLInputElement>(
			// 	document.getElementById('appearance-preview-card-shortcode')
			// );

			let donationOptionMain = <HTMLInputElement>(
				document.getElementById('donation-option-amount')
			);

			let donationOptionOpenMain = <HTMLInputElement>(
				document.getElementById('donation-option-open-amount')
			);
			var otherAmountInputDiv = <HTMLInputElement>(document.getElementById(`other-amount-div-${self.id}`));

			if (
				target &&
				target instanceof HTMLInputElement &&
				target.type === 'radio' &&
				target.name === `period-intervals-${self.id}`
			) {
				if (target.value == 'once') {
					self.selectedInterval = 'once';
					self.changeFirstAmountByIntervals(self.valueChangeFirstAmount);
					self.changeSecondAmountByIntervals(self.valueChangeSecondAmount);
					self.changeThirdAmountByIntervals(self.valueChangeThirdAmount);
					self.changeForthAmountByIntervals(self.valueChangeFourthAmount);
					self.changeFifthAmountByIntervals(self.valueChangeFifthAmount);

					if (self.onetimeOpenAmountChecked == false) {
						donationOptionMain.style.display = 'flex';
						donationOptionOpenMain.style.display = 'none';
						otherAmountInputDiv.style.display = 'flex';
					} else {
						donationOptionMain.style.display = 'none';
						donationOptionOpenMain.style.display = 'flex';
						otherAmountInputDiv.style.display = 'none';
					}
				} else if (target.value == 'monthly') {
					self.selectedInterval = 'monthly';
					self.changeFirstAmountByIntervals(self.valueChangeFirstAmountMonthly);
					self.changeSecondAmountByIntervals(
						self.valueChangeSecondAmountMonthly
					);
					self.changeThirdAmountByIntervals(self.valueChangeThirdAmountMonthly);
					self.changeForthAmountByIntervals(
						self.valueChangeFourthAmountMonthly
					);
					self.changeFifthAmountByIntervals(self.valueChangeFifthAmountMonthly);

					if (self.monthlyOpenAmountChecked == false) {
						donationOptionMain.style.display = 'flex';
						donationOptionOpenMain.style.display = 'none';
						otherAmountInputDiv.style.display = 'flex';
					} else {
						donationOptionMain.style.display = 'none';
						donationOptionOpenMain.style.display = 'flex';
						otherAmountInputDiv.style.display = 'none';
					}
				} else if (target.value == 'yearly') {
					self.selectedInterval = 'yearly';
					self.changeFirstAmountByIntervals(self.valueChangeFirstAmountYearly);
					self.changeSecondAmountByIntervals(
						self.valueChangeSecondAmountYearly
					);
					self.changeThirdAmountByIntervals(self.valueChangeThirdAmountYearly);
					self.changeForthAmountByIntervals(self.valueChangeFourthAmountYearly);
					self.changeFifthAmountByIntervals(self.valueChangeFifthAmountYearly);
					
					if (self.yearlyOpenAmountChecked == false) {
						donationOptionMain.style.display = 'flex';
						donationOptionOpenMain.style.display = 'none';
						otherAmountInputDiv.style.display = 'flex';
					} else {
						donationOptionMain.style.display = 'none';
						donationOptionOpenMain.style.display = 'flex';
						otherAmountInputDiv.style.display = 'none';
					}
				}
			}

			self.changeFifthAmount();
		});
		this.screenWidth = window.innerWidth;

		this.checkDisabledState();
	}

	ngAfterViewInit(): void {
		var targetDiv: HTMLElement | null = document.getElementById('preview_box');

		// Find all elements with onclick attribute inside the div
		if (targetDiv) {
			var elementsWithOnclick = targetDiv.querySelectorAll('[onclick]');

			// Remove onclick attribute from each element
			elementsWithOnclick.forEach(function (element) {
				element.removeAttribute('onclick');
			});
		}
	}

	// Method to load an external script
	private loadScript(scriptUrl: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			// Check if the script with the specified src already exists
			const existingScript = document.querySelector(
				`script[src="${scriptUrl}"]`
			);

			if (existingScript) {
				// Script is already present, resolve immediately
				resolve();
			} else {
				// Script is not present, load it dynamically
				const scriptElement = document.createElement('script');
				scriptElement.src = scriptUrl;
				scriptElement.onload = () => resolve();
				scriptElement.onerror = reject;
				document.head.appendChild(scriptElement);
			}
		});
	}

	// Method to call the shortcode_func_html_generator function
	private callpreview_html_generator(item: any): void | any {
		// Assuming shortcode_func_html_generator is a global function in the loaded script
		if (typeof (window as any).shortcode_func_html_generator === 'function') {
			// Call the function
			return (window as any).edit_preview_html_generator(item, this.lang);
		} else {
			console.error(
				'shortcode_func_html_generator not found in the loaded script'
			);
		}
	}

	private sanitizeHTML(html: string): string {
		// Use a DOMParser to parse the HTML string and create a DOM object
		const doc = new DOMParser().parseFromString(html, 'text/html');

		// Find all elements with onclick attributes and remove them
		const elementsWithOnclick = doc.querySelectorAll('[onclick]');
		elementsWithOnclick.forEach((element) => {
			element.removeAttribute('onclick');
		});

		// Serialize the modified DOM object back to an HTML string
		return doc.body.innerHTML;
	}

	goBack() {
		this.router.navigate(['/fundraising/widget']);
	}

	changeFontFamily() {
		// Get the div element by its id
		var containerDiv = document.getElementById('preview_box');

		// Check if the div exists
		if (containerDiv) {
			// Get all elements inside the div
			var elements: any = containerDiv.getElementsByTagName('*');

			// Loop through each element and modify the font-family
			for (var i = 0; i < elements.length; i++) {
				elements[i].style.fontFamily = this.widgetFontName;
			}
		}
	}

	getCurrencyDetailsAndRender() {
		this.fundraiserService
			.getMaxTargetAmountByCurrency(this.currencyCode)
			.subscribe((res: any) => {
				this.currencySymbol = res?.data?.list_of_currencies?.[0]?.symbol;
				this.currencyMaxAmount =
					res?.data?.list_of_currencies?.[0]?.max_target_amount;

				this.showDonationFormOnlyChecked =
					this.style_data.showDonationFormOnly != 0 ? true : false;
				this.showDonationFormOnly(this.showDonationFormOnlyChecked);

				// this.showAmountOtherChecked =
				// 	this.style_data.otherChecked != 0 ? true : false;
				this.showOtherAmount(false);

				// Donation intervals
				this.showHideOneTimeChecked =
					this.style_data.oneTimeCheck != 0 ? true : false;
				this.showHideOneTime(this.showHideOneTimeChecked);

				this.showHideMonthlyChecked =
					this.style_data.monthlyCheck != 0 ? true : false;
				this.showHideMonthly(this.showHideMonthlyChecked);

				this.showHideYearlyChecked =
					this.style_data.yearlyCheck != 0 ? true : false;
				this.showHideYearly(this.showHideYearlyChecked);

				// Branding options
				this.currentPrimaryColor = this.style_data.primaryColor;
				this.onchangePrimaryColor();

				this.currentSecondaryColor = this.style_data.secondaryColor;
				this.onchangeSecondaryColor();

				this.currentButtonRadius = this.style_data.buttonRadius;
				this.changeButtonRadius(this.currentButtonRadius);

				this.valuechangeDonationLabel = this.style_data.donationTitle;
				this.changeDonationLabel(this.valuechangeDonationLabel);

				// Donation intervals
				this.onetimeOpenAmountChecked =
					this.style_data.open_amount != 0 ? true : false;
				this.openorcustomamount();

				this.monthlyOpenAmountChecked =
					this.style_data.open_amount_monthly != 0 ? true : false;
				this.openorcustomamount_monthly();

				this.yearlyOpenAmountChecked =
					this.style_data.open_amount_yearly != 0 ? true : false;
				this.openorcustomamount_yearly();

				this.showMainImageChecked =
					this.style_data.background_allowed != 0 ? true : false;
				this.showMainImage();

				this.boxShadowNumber = this.style_data.card_shadow;
				this.updateBoxShadow();

				this.valueChangeFirstAmount = this.style_data.firstAmount;
				this.changeFirstAmount();

				this.valueChangeSecondAmount = this.style_data.secondAmount;
				this.changeSecondAmount();

				this.valueChangeThirdAmount = this.style_data.thirdAmount;
				this.changeThirdAmount();

				this.valueChangeFourthAmount = this.style_data.forthAmount;
				this.changeForthAmount();

				this.valueChangeFifthAmount = this.style_data.fifthAmount;
				this.changeFifthAmount();

				this.widgetFontName = this.style_data.font;

				this.showDonateCard = this.style_data.doNotShowBox == 1 ? false : true;
				this.onShowDonateButtonOnly();

				this.onFundraiserSelectionChange();
				this.isLoading = false;
			});
	}

	getCurrencyDetailsAndRenderDefault() {
		this.showDonationFormOnly(this.showDonationFormOnlyChecked);
		this.changeFirstAmount();
		this.changeSecondAmount();
		this.changeThirdAmount();
		this.changeForthAmount();
		this.changeFifthAmount()

		// this.showOtherAmount(this.showAmountOtherChecked);
		this.showOtherAmount(false);

		// Donation intervals
		this.showHideOneTime(this.showHideOneTimeChecked);
		this.showHideMonthly(this.showHideMonthlyChecked);
		this.showHideYearly(this.showHideYearlyChecked);

		// Branding options
		this.onchangePrimaryColor();
		this.onchangeSecondaryColor();
		this.changeButtonRadius(this.currentButtonRadius);
		this.changeDonationLabel(this.valuechangeDonationLabel);

		// Donation intervals
		this.openorcustomamount();
		this.openorcustomamount_monthly();
		this.openorcustomamount_yearly();
		this.showMainImage();
		this.updateBoxShadow();
		this.onShowDonateButtonOnly();
		this.onFundraiserCurrenyDefault();
		this.changeFontFamily();
		// this.onFundraiserSelectionChange();
		this.isLoading = false;
	}

	onshowDonationFormOnly() {
		this.showDonationFormOnly(this.showDonationFormOnlyChecked);
	}

	showDonationFormOnly(obj: any) {
		// this.showDonateCard = false;

		var appearancePreview = <HTMLInputElement>(
			document.getElementById('appearance-preview')
		);

		const donateButton = <HTMLInputElement>(
			document.getElementById('select-donate-button')
		);
		const progressBar = <HTMLInputElement>(
			document.getElementById('select-progress-bar')
		);
		const raisedAmount = <HTMLInputElement>(
			document.getElementById('select-raised-amount')
		);
		const showDaysLeft = <HTMLInputElement>(
			document.getElementById('select-show-days-left')
		);
		const donotShowBox = <HTMLInputElement>(
			document.getElementById('select-donot-show-box')
		);

		const donotShowBoxForm = <HTMLInputElement>(
			document.getElementById('select-show-donate-form-only')
		);

		let selectBackgroundImageForm = <HTMLInputElement>(
			document.getElementById('form-image-background')
		);

		let styleContainerShortcode = <HTMLInputElement>(
			document.getElementById('style-container-shortcode')
		);

		let progressBarModal = <HTMLInputElement>(
			document.getElementById(`progress-bar-modal-${this.id}`)
		);

		let closeButton = <HTMLInputElement>document.getElementById(this.id);

		if (obj) {
			if (appearancePreview) {
				appearancePreview.style.opacity = '0';
			}
			if (donateButton) {
				donateButton.disabled = obj;
			}

			if (progressBar) {
				progressBar.disabled = obj;
			}

			if (raisedAmount) {
				raisedAmount.disabled = obj;
			}

			if (showDaysLeft) {
				showDaysLeft.disabled = obj;
			}

			if (donotShowBox) {
				donotShowBox.disabled = obj;
			}

			if (donotShowBoxForm) {
				donotShowBoxForm.value = '1';
			}

			if (selectBackgroundImageForm != null && this.showMainImageChecked) {
				selectBackgroundImageForm.style.display = '';
			}

			if (styleContainerShortcode) {
				styleContainerShortcode.style.display = 'none';
			}

			if (progressBarModal) {
				progressBarModal.style.display = '';
			}

			if (closeButton) {
				closeButton.style.display = 'none';
			}
		} else {
			if (appearancePreview) {
				appearancePreview.style.opacity = '1';
			}
			if (donateButton) {
				donateButton.disabled = obj;
			}

			if (progressBar) {
				progressBar.disabled = obj;
			}

			if (raisedAmount) {
				raisedAmount.disabled = obj;
			}

			if (showDaysLeft) {
				showDaysLeft.disabled = obj;
			}

			if (donotShowBox) {
				donotShowBox.disabled = obj;
			}

			if (donotShowBoxForm) {
				donotShowBoxForm.value = '0';
			}

			if (selectBackgroundImageForm && this.showMainImageChecked) {
				selectBackgroundImageForm.style.display = 'none';
			}

			if (styleContainerShortcode) {
				styleContainerShortcode.style.display = '';
			}

			if (progressBarModal) {
				progressBarModal.style.display = 'none';
			}

			if (closeButton) {
				closeButton.style.display = '';
			}
		}
		this.updateBoxShadow();
	}

	changeFirstAmount() {
		var previewTextFirstAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-1-label-${this.id}`)
		);
		
		if (previewTextFirstAmount) {
			if (this.selectedInterval == 'once') {
				previewTextFirstAmount.innerHTML =
					this.currencySymbol + this.valueChangeFirstAmount;
			} else if (this.selectedInterval == 'monthly') {
				previewTextFirstAmount.innerHTML =
					this.currencySymbol + this.valueChangeFirstAmountMonthly;
			} else if (this.selectedInterval == 'yearly') {
				previewTextFirstAmount.innerHTML =
					this.currencySymbol + this.valueChangeFirstAmountYearly;
			}
		}
		this.checkDisabledState();
	}

	changeSecondAmount() {
		var previewTextSecondAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-2-label-${this.id}`)
		);
		if (previewTextSecondAmount) {
			if (this.selectedInterval == 'once') {
				previewTextSecondAmount.innerHTML =
					this.currencySymbol + this.valueChangeSecondAmount;
			} else if (this.selectedInterval == 'monthly') {
				previewTextSecondAmount.innerHTML =
					this.currencySymbol + this.valueChangeSecondAmountMonthly;
			} else if (this.selectedInterval == 'yearly') {
				previewTextSecondAmount.innerHTML =
					this.currencySymbol + this.valueChangeSecondAmountYearly;
			}
			this.checkDisabledState();
		}
	}

	changeThirdAmount() {
		var previewTextThirdAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-3-label-${this.id}`)
		);
		// previewTextThirdAmount.innerHTML = this.currencySymbol + this.valueChangeThirdAmount;
		if (previewTextThirdAmount) {
			if (this.selectedInterval == 'once') {
				previewTextThirdAmount.innerHTML =
					this.currencySymbol + this.valueChangeThirdAmount;
			} else if (this.selectedInterval == 'monthly') {
				previewTextThirdAmount.innerHTML =
					this.currencySymbol + this.valueChangeThirdAmountMonthly;
			} else if (this.selectedInterval == 'yearly') {
				previewTextThirdAmount.innerHTML =
					this.currencySymbol + this.valueChangeThirdAmountYearly;
			}
		}
		this.checkDisabledState();
	}

	changeForthAmount() {
		var previewTextForthAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-4-label-${this.id}`)
		);

		// previewTextForthAmount.innerHTML = this.currencySymbol + this.valueChangeFourthAmount;
		if (previewTextForthAmount) {
			if (this.selectedInterval == 'once') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFourthAmount;
			} else if (this.selectedInterval == 'monthly') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFourthAmountMonthly;
			} else if (this.selectedInterval == 'yearly') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFourthAmountYearly;
			}
		}
		this.checkDisabledState();
	}

	changeFifthAmount() {
		var previewTextForthAmount = <HTMLInputElement>(document.getElementById(`amount-boundary-box-5-label-${this.id}`));
		var previewTextForthAmountBox = <HTMLInputElement>(document.getElementById(`amount-boundary-box-5-s-${this.id}`));
		// previewTextForthAmount.innerHTML = this.currencySymbol + this.valueChangeFourthAmount;
		if (previewTextForthAmount) {
			if (this.selectedInterval == 'once') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFifthAmount;
			} else if (this.selectedInterval == 'monthly') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFifthAmountMonthly;
			} else if (this.selectedInterval == 'yearly') {
				previewTextForthAmount.innerHTML =
					this.currencySymbol + this.valueChangeFifthAmountYearly;
			}

			let shouldShow = false;

			if (this.selectedInterval === 'once' && this.valueChangeFifthAmount > 0) {
			  shouldShow = true;
			} else if (this.selectedInterval === 'monthly' && this.valueChangeFifthAmountMonthly > 0) {
			  shouldShow = true;
			} else if (this.selectedInterval === 'yearly' && this.valueChangeFifthAmountYearly > 0) {
			  shouldShow = true;
			}
			
			if (shouldShow) {
			  previewTextForthAmountBox.style.setProperty('display', 'initial');
			} else {
			  previewTextForthAmountBox.style.setProperty('display', 'none', 'important');
			}
			
			// } else if (this.selectedInterval == 'monthly') {
			// 	previewTextForthAmount.innerHTML =
			// 		this.currencySymbol + this.valueChangeFifthAmountMonthly;
			// } else if (this.selectedInterval == 'yearly') {
			// 	previewTextForthAmount.innerHTML =
			// 		this.currencySymbol + this.valueChangeFifthAmountYearly;
			// }

		}
		this.checkDisabledState();
	}

	onshowOtherAmount() {
		this.showOtherAmount(this.showAmountOtherChecked);
	}

	showOtherAmount(obj: any) {
		// Retrieve the element
		const previewDivforOtherAmount = document.getElementById(
			`amount-boundary-box-other-s-${this.id}`
		) as HTMLElement;
		const selectOtherElement = document.getElementById(
			'select-other'
		) as HTMLInputElement;

		// Check if the element exists
		if (previewDivforOtherAmount) {
			// Set the display style with !important
			previewDivforOtherAmount.style.cssText = obj
				? 'display: flex !important;'
				: 'display: none !important;';
		}

		if (selectOtherElement) {
			// Update the value of select-other
			selectOtherElement.value = obj ? '1' : '0';
		}
	}

	// Intervals - One Time, Monthly, Yearly
	changeFirstAmountByIntervals(amount: any) {
		var previewTextFirstAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-1-label-${this.id}`)
		);
		previewTextFirstAmount.innerHTML = this.currencySymbol + amount;
	}

	changeSecondAmountByIntervals(amount: any) {
		var previewTextSecondAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-2-label-${this.id}`)
		);
		previewTextSecondAmount.innerHTML = this.currencySymbol + amount;
	}

	changeThirdAmountByIntervals(amount: any) {
		var previewTextThirdAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-3-label-${this.id}`)
		);
		previewTextThirdAmount.innerHTML = this.currencySymbol + amount;
	}

	changeForthAmountByIntervals(amount: any) {
		var previewTextForthAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-4-label-${this.id}`)
		);
		previewTextForthAmount.innerHTML = this.currencySymbol + amount;
	}

	
	changeFifthAmountByIntervals(amount: any) {
		var previewTextForthAmount = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-5-label-${this.id}`)
		);
		previewTextForthAmount.innerHTML = this.currencySymbol + amount;
	}

	checkDisabledState() {
		this.disabled =
			(!this.showHideOneTimeChecked &&
				!this.showHideMonthlyChecked &&
				!this.showHideYearlyChecked) ||
			this.selectedFundraiser === -1 ||
			this.fundraiser_list[this.selectedFundraiser].slug == '' ||
			(!this.onetimeOpenAmountChecked &&
				(this.valueChangeFirstAmount < this.currencyMinAmount ||
					this.valueChangeFirstAmount > this.currencyMaxAmount)) ||
			(!this.onetimeOpenAmountChecked &&
				(this.valueChangeSecondAmount < this.currencyMinAmount ||
					this.valueChangeSecondAmount > this.currencyMaxAmount)) ||
			(!this.onetimeOpenAmountChecked &&
				(this.valueChangeThirdAmount < this.currencyMinAmount ||
					this.valueChangeThirdAmount > this.currencyMaxAmount)) ||
			(!this.onetimeOpenAmountChecked &&
				(this.valueChangeFourthAmount < this.currencyMinAmount ||
					this.valueChangeFourthAmount > this.currencyMaxAmount)) ||
			(!this.monthlyOpenAmountChecked &&
				(this.valueChangeFirstAmountMonthly < this.currencyMinAmount ||
					this.valueChangeFirstAmountMonthly > this.currencyMaxAmount)) ||
			(!this.monthlyOpenAmountChecked &&
				(this.valueChangeSecondAmountMonthly < this.currencyMinAmount ||
					this.valueChangeSecondAmountMonthly > this.currencyMaxAmount)) ||
			(!this.monthlyOpenAmountChecked &&
				(this.valueChangeThirdAmountMonthly < this.currencyMinAmount ||
					this.valueChangeThirdAmountMonthly > this.currencyMaxAmount)) ||
			(!this.monthlyOpenAmountChecked &&
				(this.valueChangeFourthAmountMonthly < this.currencyMinAmount ||
					this.valueChangeFourthAmountMonthly > this.currencyMaxAmount)) ||
			(!this.yearlyOpenAmountChecked &&
				(this.valueChangeFirstAmountYearly < this.currencyMinAmount ||
					this.valueChangeFirstAmountYearly > this.currencyMaxAmount)) ||
			(!this.yearlyOpenAmountChecked &&
				(this.valueChangeSecondAmountYearly < this.currencyMinAmount ||
					this.valueChangeSecondAmountYearly > this.currencyMaxAmount)) ||
			(!this.yearlyOpenAmountChecked &&
				(this.valueChangeThirdAmountYearly < this.currencyMinAmount ||
					this.valueChangeThirdAmountYearly > this.currencyMaxAmount)) ||
			(!this.yearlyOpenAmountChecked &&
				(this.valueChangeFourthAmountYearly < this.currencyMinAmount ||
					this.valueChangeFourthAmountYearly > this.currencyMaxAmount)) ||
			(!this.onetimeOpenAmountChecked &&
				(this.valueChangeFifthAmount != 0 && this.valueChangeFifthAmount < this.currencyMinAmount ||
					this.valueChangeFifthAmount > this.currencyMaxAmount)) ||
			(!this.monthlyOpenAmountChecked &&
				(this.valueChangeFifthAmountMonthly != 0 && this.valueChangeFifthAmountMonthly < this.currencyMinAmount ||
					this.valueChangeFifthAmountMonthly > this.currencyMaxAmount)) ||
			(!this.yearlyOpenAmountChecked &&
				(this.valueChangeFifthAmountYearly != 0 && this.valueChangeFifthAmountYearly < this.currencyMinAmount ||
					this.valueChangeFifthAmountYearly > this.currencyMaxAmount));
		}
		
	onshowHideOneTime() {
		this.showHideOneTime(this.showHideOneTimeChecked);
		const selectAmountSection = document.getElementById(
			'select-amount-section'
		);
		if (selectAmountSection) {
			selectAmountSection.style.display = this.showHideOneTimeChecked
				? 'none'
				: 'block';
		}

		// if (
		// 	this.showHideOneTimeChecked == false &&
		// 	this.showHideMonthlyChecked == false
		// ) {
		// 	this.showHideYearlyChecked = true;
		// } else
		if (
			this.showHideMonthlyChecked == false &&
			this.showHideYearlyChecked == false
		) {
			this.showHideOneTimeChecked = true;
		}
		// else if (
		// 	this.showHideOneTimeChecked == false &&
		// 	this.showHideMonthlyChecked == false
		// ) {
		// 	this.showHideYearlyChecked = true;
		// }

		this.checkDisabledState();
	}

	showHideOneTime(obj: any) {
		var periodIntervalOnetime = <HTMLInputElement>(
			document.getElementById(`preview-intervals-onetime-${this.id}`)
		);
		if (periodIntervalOnetime) {
			if (obj) {
				periodIntervalOnetime.style.display = 'flex';
			} else {
				periodIntervalOnetime.style.display = 'none';
			}
		}

		var periodIntervalOnetime = <HTMLInputElement>(
			document.getElementById(`preview-intervals-onetime-bar-${this.id}`)
		);
		if (periodIntervalOnetime) {
			if (obj) {
				periodIntervalOnetime.style.display = '';
			} else {
				periodIntervalOnetime.style.display = 'none';
			}
		}
	}	

	onshowHideMonthly() {
		this.showHideMonthly(this.showHideMonthlyChecked);
	}

	showHideMonthly(obj: any) {
		var periodIntervalMonthly = <HTMLInputElement>(
			document.getElementById(`preview-intervals-monthly-${this.id}`)
		);
		if (periodIntervalMonthly) {
			if (obj) {
				periodIntervalMonthly.style.display = 'flex';
			} else {
				periodIntervalMonthly.style.display = 'none';
			}
		}

		var periodIntervalMonthly = <HTMLInputElement>(
			document.getElementById(`preview-intervals-monthly-bar-${this.id}`)
		);
		if (periodIntervalMonthly) {
			if (obj) {
				periodIntervalMonthly.style.display = '';
			} else {
				periodIntervalMonthly.style.display = 'none';
			}
		}
		this.checkDisabledState();
	}

	onshowHideYearly() {
		this.showHideYearly(this.showHideYearlyChecked);
		this.checkDisabledState();
	}

	showHideYearly(obj: any) {
		var periodIntervalYearly = <HTMLInputElement>(
			document.getElementById(`preview-intervals-yearly-${this.id}`)
		);
		if (periodIntervalYearly) {
			if (obj) {
				periodIntervalYearly.style.display = 'flex';
			} else {
				periodIntervalYearly.style.display = 'none';
			}
		}

		var periodIntervalYearly = <HTMLInputElement>(
			document.getElementById(`preview-intervals-yearly-bar-${this.id}`)
		);
		if (periodIntervalYearly) {
			if (obj) {
				periodIntervalYearly.style.display = '';
			} else {
				periodIntervalYearly.style.display = 'none';
			}
		}
		this.checkDisabledState();
	}

	onchangePrimaryColor() {
		this.changePrimaryColor(this.currentPrimaryColor);
	}

	changePrimaryColor(color: any) {
		var colorInputField = <HTMLInputElement>(
			document.getElementById('set-color-input-field-primary')
		);
		var colorInput = <HTMLInputElement>(
			document.getElementById('set-color-input-primary')
		);
		if (colorInputField) {
			colorInputField.value = color;
		}

		if (colorInput) {
			colorInput.value = color;
		}

		// var previewHeader = <HTMLInputElement>(
		// 	document.getElementById(`preview-header-${this.id}`)
		// );
		// previewHeader.style.backgroundColor = color;

		// var previewDonateBtn = <HTMLInputElement>(
		// 	document.getElementById(`preview-donate-btn-${this.id}`)
		// );
		// previewDonateBtn.style.backgroundColor = color;

		var firstAmountOptionDiv = <HTMLInputElement>(
			document.getElementById(`amount-boundary-box-1-s-${this.id}`)
		);

		if (firstAmountOptionDiv) {
			// Remove the onchange attribute
			firstAmountOptionDiv.style.backgroundColor = color;
		}

		var onetimeSectionDiv = <HTMLInputElement>(
			document.getElementById(`preview-select-amount-options-${this.id}`)
		);

		if (onetimeSectionDiv) {
			// Add a new class to the div
			onetimeSectionDiv.classList.add('disabled-overlay');
		}

		var currencyOptions = <HTMLInputElement>(
			document.getElementById('currency-options')
		);
		if (currencyOptions) {
			// Add a new class to the div
			currencyOptions.classList.add('disabled-overlay');
		}

		let apreviewRaisedBar = document.querySelectorAll('[id="apreview-raised-bar"]');

		apreviewRaisedBar.forEach((element : any) => {
			element.style.backgroundColor = color;
		});
	}

	onchangeSecondaryColor() {
		this.changeSecondaryColor(this.currentSecondaryColor);
	}

	changeSecondaryColor(color: any) {
		var colorInputField = <HTMLInputElement>(
			document.getElementById('set-color-input-field-secondary')
		);
		var colorInput = <HTMLInputElement>(
			document.getElementById('set-color-input-secondary')
		);
		if (colorInputField) {
			colorInputField.value = color;
		}

		if (colorInput) {
			colorInput.value = color;
		}

		var appearanceDonateBtn = <HTMLInputElement>(
			document.getElementById(`apreview-donate-btn-${this.id}`)
		);
		if (appearanceDonateBtn) {
			appearanceDonateBtn.style.backgroundColor = color;
		}

		var previewHeader = <HTMLInputElement>(
			document.getElementById(`preview-header-${this.id}`)
		);
		if (previewHeader) {
			previewHeader.style.backgroundColor = color;
		}

		var previewDonateBtn = <HTMLInputElement>(
			document.getElementById(`preview-amount-next-btn-${this.id}`)
		);
		if (previewDonateBtn) {
			previewDonateBtn.style.backgroundColor = color;
		}

		if (this.selectedInterval == 'once') {
			var previewDividerOnetime = <HTMLInputElement>(
				document.getElementById(`preview-intervals-onetime-bar-${this.id}`)
			);
			if (previewDividerOnetime) {
				previewDividerOnetime.style.backgroundColor = color;
			}
		}
		if (this.selectedInterval == 'monthly') {
			var previewDividerMonthly = <HTMLInputElement>(
				document.getElementById(`preview-intervals-monthly-bar-${this.id}`)
			);
			if (previewDividerMonthly) {
				previewDividerMonthly.style.backgroundColor = color;
			}
		}

		if (this.selectedInterval == 'yearly') {
			var previewDividerYearly = <HTMLInputElement>(
				document.getElementById(`preview-intervals-yearly-bar-${this.id}`)
			);
			if (previewDividerYearly) {
				previewDividerYearly.style.backgroundColor = color;
			}
		}
	}

	onchangeButtonRadius() {
		this.changeButtonRadius(this.currentButtonRadius);
	}

	changeButtonRadius(value: any): void {
		const appearanceDonateBtn = document.getElementById(
			`apreview-donate-btn-${this.id}`
		);
		const previewDonateBtn = document.getElementById(
			`preview-amount-next-btn-${this.id}`
		);

		if (appearanceDonateBtn && previewDonateBtn) {
			const radiusValue = value + 'px';
			appearanceDonateBtn.style.borderRadius = radiusValue;
			previewDonateBtn.style.borderRadius = radiusValue;
		}
	}

	onchangeDonationLabel() {
		this.changeDonationLabel(this.valuechangeDonationLabel);
	}

	changeDonationLabel(obj: any): void {
		const label = document.getElementById(`preview-header-label-${this.id}`);
		if (label) {
			label.innerText = obj;
		}
	}

	generateRandomCombination() {
		const characters =
			'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		const combinationLength = 5;

		let randomCombination = '';

		for (let i = 0; i < combinationLength; i++) {
			const randomIndex = Math.floor(Math.random() * characters.length);
			randomCombination += characters[randomIndex];
		}

		return randomCombination;
	}

	openorcustomamount() {
		// Get references to HTML elements with specific IDs
		let donationOption = document.getElementById(
			'donation-option-amount'
		) as HTMLElement;
		let donationOptionOpen = document.getElementById(
			'donation-option-open-amount'
		) as HTMLElement;

		// Get references to the input fields
		let inputFirstAmount = document.getElementById(
			'select-first-amount'
		) as HTMLInputElement;
		let inputSecondAmount = document.getElementById(
			'select-second-amount'
		) as HTMLInputElement;
		let inputThirdAmount = document.getElementById(
			'select-third-amount'
		) as HTMLInputElement;
		let inputFourthAmount = document.getElementById(
			'select-forth-amount'
		) as HTMLInputElement;

		if (!this.onetimeOpenAmountChecked) {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = false;
			}

			if (inputSecondAmount) {
				inputSecondAmount.disabled = false;
			}

			if (inputThirdAmount) {
				inputThirdAmount.disabled = false;
			}

			if (inputFourthAmount) {
				inputFourthAmount.disabled = false;
			}
		} else {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = true;
			}

			if (inputSecondAmount) {
				inputSecondAmount.disabled = true;
			}

			if (inputThirdAmount) {
				inputThirdAmount.disabled = true;
			}

			if (inputFourthAmount) {
				inputFourthAmount.disabled = true;
			}
		}

		// Check if this.onetimeOpenAmountChecked is truthy
		if (this.selectedInterval === 'once') {
			var otherAmountInputDiv = <HTMLInputElement>(document.getElementById(`other-amount-div-${this.id}`));
			if(otherAmountInputDiv) {
				if (!this.onetimeOpenAmountChecked) {
					otherAmountInputDiv.style.setProperty('display', 'flex', 'important');
				} else {
					otherAmountInputDiv.style.setProperty('display', 'none', 'important');
				}
			}

			if (!this.onetimeOpenAmountChecked) {
				if (donationOption) {
					donationOption.style.display = 'flex';
					donationOption.style.flexDirection = 'row';
					donationOption.style.gap = '16px';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = 'none';
				}
			} else {
				if (donationOption) {
					donationOption.style.display = 'none';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = '';
				}
			}
		}

		this.checkDisabledState();
	}

	openorcustomamount_monthly() {
		// Get references to HTML elements with specific IDs
		let donationOption = <HTMLInputElement>(
			document.getElementById('donation-option-amount')
		);
		let donationOptionOpen = <HTMLInputElement>(
			document.getElementById('donation-option-open-amount')
		);
		let inputFirstAmount = document.getElementById(
			'select-first-amount-monthly'
		) as HTMLInputElement;
		let inputSecondAmount = document.getElementById(
			'select-second-amount-monthly'
		) as HTMLInputElement;
		let inputThirdAmount = document.getElementById(
			'select-third-amount-monthly'
		) as HTMLInputElement;
		let inputFourthAmount = document.getElementById(
			'select-forth-amount-monthly'
		) as HTMLInputElement;
		// Check if the element and its style property are truthy
		// if (
		// 	donationOptionOnetime &&
		// 	donationOptionOnetime.style &&
		// 	donationOptionOnetimeOpen &&
		// 	donationOptionOnetimeOpen.style
		// ) {
		// Check if this.monthlyOpenAmountChecked is truthy
		if (!this.monthlyOpenAmountChecked) {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = false;
			}
			if (inputSecondAmount) {
				inputSecondAmount.disabled = false;
			}
			if (inputThirdAmount) {
				inputThirdAmount.disabled = false;
			}
			if (inputFourthAmount) {
				inputFourthAmount.disabled = false;
			}
		} else {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = true;
			}
			if (inputSecondAmount) {
				inputSecondAmount.disabled = true;
			}
			if (inputThirdAmount) {
				inputThirdAmount.disabled = true;
			}
			if (inputFourthAmount) {
				inputFourthAmount.disabled = true;
			}
		}

		if (this.selectedInterval === 'monthly') {
			var otherAmountInputDiv = <HTMLInputElement>(document.getElementById(`other-amount-div-${this.id}`));
			if(otherAmountInputDiv) {
				if (!this.monthlyOpenAmountChecked) {
					otherAmountInputDiv.style.setProperty('display', 'flex', 'important');
				} else {
					otherAmountInputDiv.style.setProperty('display', 'none', 'important');
				}
			}

			if (!this.monthlyOpenAmountChecked) {
				if (donationOption) {
					donationOption.style.display = 'flex';
					donationOption.style.flexDirection = 'row';
					donationOption.style.gap = '16px';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = 'none';
				}
			} else {
				if (donationOption) {
					donationOption.style.display = 'none';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = '';
				}
			}
		}

		this.checkDisabledState();
		// }
	}

	openorcustomamount_yearly() {
		// Get references to HTML elements with specific IDs
		let donationOption = <HTMLInputElement>(
			document.getElementById('donation-option-amount')
		);
		let donationOptionOpen = <HTMLInputElement>(
			document.getElementById('donation-option-open-amount')
		);

		let inputFirstAmount = document.getElementById(
			'select-first-amount-yearly'
		) as HTMLInputElement;
		let inputSecondAmount = document.getElementById(
			'select-second-amount-yearly'
		) as HTMLInputElement;
		let inputThirdAmount = document.getElementById(
			'select-third-amount-yearly'
		) as HTMLInputElement;
		let inputFourthAmount = document.getElementById(
			'select-forth-amount-yearly'
		) as HTMLInputElement;
		// Check if the element and its style property are truthy
		// if (
		// 	donationOptionOnetime &&
		// 	donationOptionOnetime.style &&
		// 	donationOptionOnetimeOpen &&
		// 	donationOptionOnetimeOpen.style
		// ) {
		// Check if this.yearlyOpenAmountChecked is truthy
		if (!this.yearlyOpenAmountChecked) {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = false;
			}
			if (inputSecondAmount) {
				inputSecondAmount.disabled = false;
			}
			if (inputThirdAmount) {
				inputThirdAmount.disabled = false;
			}
			if (inputFourthAmount) {
				inputFourthAmount.disabled = false;
			}
		} else {
			if (inputFirstAmount) {
				inputFirstAmount.disabled = true;
			}
			if (inputSecondAmount) {
				inputSecondAmount.disabled = true;
			}
			if (inputThirdAmount) {
				inputThirdAmount.disabled = true;
			}
			if (inputFourthAmount) {
				inputFourthAmount.disabled = true;
			}
		}

		if (this.selectedInterval === 'yearly') {
			var otherAmountInputDiv = <HTMLInputElement>(document.getElementById(`other-amount-div-${this.id}`));
			if(otherAmountInputDiv) {
				if (!this.yearlyOpenAmountChecked) {
					otherAmountInputDiv.style.setProperty('display', 'flex', 'important');
				} else {
					otherAmountInputDiv.style.setProperty('display', 'none', 'important');
				}
			}	

			if (!this.yearlyOpenAmountChecked) {
				if (donationOption) {
					donationOption.style.display = 'flex';
					donationOption.style.flexDirection = 'row';
					donationOption.style.gap = '16px';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = 'none';
				}
			} else {
				if (donationOption) {
					donationOption.style.display = 'none';
				}
				if (donationOptionOpen) {
					donationOptionOpen.style.display = '';
				}
			}
		}

		this.checkDisabledState();
		// }
	}

	boxShadowSet(value: any) {
		// Your existing cases to determine the new box-shadow value
		let newBoxShadow = '';
		if (value == 'none') {
			newBoxShadow = 'none ';
		} else if (value == 1) {
			this.previewBoxShadowNumber = 1;
			this.boxShadowNumber = parseInt(value);
			newBoxShadow =
				'0 2px 1px -1px #0003, 0 1px 1px #00000024, 0 1px 3px #0000001f;';
		} else if (value == 2) {
			this.previewBoxShadowNumber = 2;
			this.boxShadowNumber = parseInt(value);
			newBoxShadow =
				'0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f';
		} else if (value == 3) {
			this.previewBoxShadowNumber = 4;
			this.boxShadowNumber = parseInt(value);
			newBoxShadow =
				'0 2px 4px -1px #0003, 0 4px 5px #00000024, 0 1px 10px #0000001f';
		}
		return newBoxShadow;
	}

	updateBoxShadow(): void {
		// if (
		//   target &&
		//   target instanceof HTMLInputElement &&
		//   target.name === 'card-shadow'
		// ) {
		// showDonationFormOnlyChecked
		let appearancePreviewCardShortcode;
		if (!this.showDonationFormOnlyChecked) {
			appearancePreviewCardShortcode = <HTMLInputElement>(
				document.getElementById('appearance-preview-card-shortcode')
			);
		} else {
			appearancePreviewCardShortcode = <HTMLInputElement>(
				document.getElementById(`preview-card-${this.id}`)
			);
		}

		if (appearancePreviewCardShortcode) {
			appearancePreviewCardShortcode.style.boxShadow = 'none';

			// Retrieve the current style attribute
			let currentStyle =
				appearancePreviewCardShortcode.getAttribute('style') || '';

			let newBoxShadow = '';

			// Condtion to check if no card is selected
			if (this.showDonateCard) {
				// Your existing cases to determine the new box-shadow value
				newBoxShadow = this.boxShadowSet(this.boxShadowNumber);
			} else {
				newBoxShadow = this.boxShadowSet('none');
			}

			// Concatenate the current style with the new box-shadow value
			let updatedStyle =
				currentStyle + ';' + 'box-shadow:' + newBoxShadow + ';';

			// Set the updated style attribute
			appearancePreviewCardShortcode.setAttribute('style', updatedStyle);
			// }
		}
	}

	showMainImage() {
		let selectBackgroundImageWidget = <HTMLInputElement>(
			document.getElementById('widget-image-background')
		);

		let selectBackgroundImageForm = <HTMLInputElement>(
			document.getElementById(`form-image-background-${this.id}`)
		);

		let appearancePreviewCardShortcode = <HTMLInputElement>(
			document.getElementById('appearance-preview-card-shortcode')
		);

		let previewCard = <HTMLInputElement>(
			document.getElementById(`preview-card-${this.id}`)
		);

		if (previewCard) {
			previewCard.style.minHeight = '340px !important';
		}

		if (this.showMainImageChecked) {
			if (selectBackgroundImageWidget) {
				selectBackgroundImageWidget.style.display = '';
			}
			if (selectBackgroundImageForm) {
				selectBackgroundImageForm.style.display = '';
			}
			if (appearancePreviewCardShortcode) {
				if (this.amount_target == 0 && this.show_donation_details == false) {
					appearancePreviewCardShortcode.style.height = '312px';
				} else {
					appearancePreviewCardShortcode.style.height = '390px';
				}
			}
		} else {
			if (selectBackgroundImageWidget) {
				selectBackgroundImageWidget.style.display = 'none';
			}
			if (selectBackgroundImageForm) {
				selectBackgroundImageForm.style.display = 'none';
			}
			if (appearancePreviewCardShortcode) {
				if (this.amount_target == 0 && this.show_donation_details == false) {
					appearancePreviewCardShortcode.style.height = '130px';
				} else {
					appearancePreviewCardShortcode.style.height = '230px';
				}
			}
		}

		if (previewCard) {
			previewCard.style.setProperty('min-height', '340px', 'important');
		}
	}

	onShowDonateButtonOnly() {
		let condition = this.showDonateCard;

		let appearancePreview = document.getElementById(
			'appearance-preview-card-shortcode'
		);

		let apreviewProgressBar = <HTMLInputElement>(
			document.getElementById('apreview-progress-bar')
		);

		let apreviewAmountRaised = <HTMLInputElement>(
			document.getElementById('apreview-amount-raised')
		);

		let selectBackgroundImageWidget = <HTMLInputElement>(
			document.getElementById('widget-image-background')
		);

		if (condition) {
			if (appearancePreview) {
				appearancePreview.style.removeProperty('background');
			}

			if (apreviewProgressBar) {
				apreviewProgressBar.style.display = '';
			}

			if (apreviewAmountRaised) {
				apreviewAmountRaised.style.display = '';
			}

			if (selectBackgroundImageWidget && this.showMainImageChecked == true) {
				selectBackgroundImageWidget.style.display = '';
			}
		} else {
			if (appearancePreview) {
				appearancePreview.style.setProperty(
					'background',
					'transparent',
					'important'
				);

				// appearancePreview.style.setProperty('box-shadow', 'none', 'important');
				// appearancePreview.style.background = 'transparent !important';
				appearancePreview.style.boxShadow = 'none  !important';
			}

			if (apreviewProgressBar) {
				apreviewProgressBar.style.display = 'none';
			}

			if (apreviewAmountRaised) {
				apreviewAmountRaised.style.display = 'none';
			}

			if (selectBackgroundImageWidget && this.showMainImageChecked == true) {
				selectBackgroundImageWidget.style.display = 'none';
			}
		}

		if (this.showDonationFormOnlyChecked == true) {
			this.showDonationFormOnlyChecked = condition;
			this.onshowDonationFormOnly();
		}
		this.updateBoxShadow();
	}

	onFundraiserCurrenyDefault() {
		if (
			this.fundraiser_list[1]?.slug != undefined ||
			this.fundraiser_list[1]?.currency_code != undefined
		)
			this.donationService
				.getDonationWpConfigurationOfFundraiser(
					this.fundraiser_list[1]?.slug,
					this.fundraiser_list[1]?.currency_code,
					this.shortcode
				)
				.subscribe((res: any) => {
					this.currencySymbol = res?.data?.symbol;
					this.currencyMinAmount = parseInt(
						res?.data?.customdonationconfiguration?.min_donation_amount
					);
					this.currencyMaxAmount = parseInt(
						res?.data?.customdonationconfiguration?.max_donation_amount
					);
					this.valueChangeFirstAmount =
						res?.data?.customdonationconfiguration?.onetime?.default_1;
					this.valueChangeSecondAmount =
						res?.data?.customdonationconfiguration?.onetime?.default_2;
					this.valueChangeThirdAmount =
						res?.data?.customdonationconfiguration?.onetime?.default_3;
					this.valueChangeFourthAmount =
						res?.data?.customdonationconfiguration?.onetime?.default_4;

					this.valueChangeFirstAmountMonthly =
						res?.data?.customdonationconfiguration?.monthly?.default_1;
					this.valueChangeSecondAmountMonthly =
						res?.data?.customdonationconfiguration?.monthly?.default_2;
					this.valueChangeThirdAmountMonthly =
						res?.data?.customdonationconfiguration?.monthly?.default_3;
					this.valueChangeFourthAmountMonthly =
						res?.data?.customdonationconfiguration?.monthly?.default_4;

					this.valueChangeFirstAmountYearly =
						res?.data?.customdonationconfiguration?.yearly?.default_1;
					this.valueChangeSecondAmountYearly =
						res?.data?.customdonationconfiguration?.yearly?.default_2;
					this.valueChangeThirdAmountYearly =
						res?.data?.customdonationconfiguration?.yearly?.default_3;
					this.valueChangeFourthAmountYearly =
						res?.data?.customdonationconfiguration?.yearly?.default_4;

					this.currencyCode = res?.data?.currency;

					this.changeFirstAmount();
					this.changeSecondAmount();
					this.changeThirdAmount();
					this.changeForthAmount();
					this.changeFifthAmount();
					let currency_symbol_elements =
						document.querySelectorAll('.currency-symbol');

					currency_symbol_elements.forEach((element) => {
						element.innerHTML =
							this.currencySymbol == undefined ? '€' : this.currencySymbol;
					});
				});
	}

	checkVideoUrl(url: string) {
		// Vimeo link pattern
		const vimeoPattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;

		// YouTube link pattern
		const youtubePattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;

		if (url.match(vimeoPattern)) {
			return this.generateVimeoIframe(url);
		} else if (url.match(youtubePattern)) {
			return this.generateYouTubeIframe(url);
		} else {
			return 'unknown';
		}
	}

	generateVimeoIframe(videoLink: string) {
		const vimeoVideoId = this.getVideoIdVimeo(videoLink);
		return `https://vumbnail.com/${vimeoVideoId}.jpg`;
	}

	generateYouTubeIframe(videoLink: string) {
		const videoId = this.getVideoIdYoutube(videoLink);
		return `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
	}

	getVideoIdYoutube(videoLink: string): string {
		// Extract the video ID from the YouTube link (including Shorts)
		const pattern =
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	getVideoIdVimeo(videoLink: string) {
		// Extract the video ID from the Vimeo link
		const pattern = /^(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)(\d+)(?:\S+)?$/;
		const match = videoLink?.match(pattern);
		return match && match[1] ? match[1] : '';
	}

	onFundraiserSelectionChange() {
		var locale = this.lang;

		this.fundraiserService
			.getFundraiserBySlug(
				this.fundraiser_list[this.selectedFundraiser].slug,
				locale
			)
			.subscribe((data: any) => {
				let selectBackgroundImageWidget = <HTMLInputElement>(
					document.getElementById('widget-image-background')
				);

				let formImageBackground = <HTMLInputElement>(
					document.getElementById(`form-image-background`)
				);

				let appearancePreviewCardShortcode = <HTMLInputElement>(
					document.getElementById('appearance-preview-card-shortcode')
				);

				let apreviewTargetAmountDiv = document.querySelectorAll(
					'[id="apreview-target-amount-div"]'
				);
				let apreviewDaysLeft = document.querySelectorAll(
					'[id="apreview-days-left"]'
				);
				let apreviewCollectedAmountDiv = document.querySelectorAll(
					'[id="apreview-collected-amount-div"]'
				);
				let apreviewRaisedBar = document.querySelectorAll(
					'[id="apreview-raised-bar"]'
				);
				let apreviewFullBar = document.querySelectorAll(
					'[id="apreview-full-bar"]'
				);

				let apreviewAchievedPercent = document.querySelectorAll(
					'[id="apreview-achieved-percent"]'
				);
				let apreviewAmountRaised = document.querySelectorAll(
					'[id="apreview-amount-raised"]'
				);
				let apreviewProgressInfo = document.querySelectorAll(
					'[id="apreview-progress-info"]'
				);
				let apreviewTargetAmountDivLabel = document.querySelectorAll(
					'[id="apreview-target-amount-div-label-1"]'
				);

				let progressBarModal;

				this.show_donation_details = data.data.result.show_donation_details;
				this.amount_target = data.data.result.amount_target;
				this.end_date = data.data.result.end_date;

				if (this.amount_target == 0) {
					apreviewTargetAmountDiv.forEach((element: any) => {
						element.style.display = 'none';
					});
				} else if (this.amount_target > 0) {
					apreviewTargetAmountDiv.forEach((element: any) => {
						element.style.display = 'inherit';
					});
				}

				if (this.end_date == '9999-12-31') {
					apreviewDaysLeft.forEach((element: any) => {
						element.style.display = 'none';
					});
				} else if (this.end_date != '9999-12-31') {
					apreviewDaysLeft.forEach((element: any) => {
						element.style.display = 'inherit';
					});
				}

				if (this.show_donation_details == true) {
					apreviewCollectedAmountDiv.forEach((element: any) => {
						element.style.display = 'inherit';
					});
					apreviewRaisedBar.forEach((element: any) => {
						element.style.display = 'inherit';
					});
					apreviewAchievedPercent.forEach((element: any) => {
						element.style.display = 'inherit';
					});
					apreviewTargetAmountDivLabel.forEach((element: any) => {
						element.style.display = 'inherit';
					});
					apreviewFullBar.forEach((element: any) => {
						element.style.display = 'inherit';
					});
				} else if (this.show_donation_details == false) {
					apreviewCollectedAmountDiv.forEach((element: any) => {
						element.style.display = 'none';
					});
					apreviewRaisedBar.forEach((element: any) => {
						element.style.display = 'none';
					});
					apreviewAchievedPercent.forEach((element: any) => {
						element.style.display = 'none';
					});
					apreviewTargetAmountDivLabel.forEach((element: any) => {
						element.style.display = 'none';
					});
					apreviewFullBar.forEach((element: any) => {
						element.style.display = 'none';
					});
				}

				if (
					this.show_donation_details == false &&
					this.end_date == '9999-12-31'
				) {
					apreviewAmountRaised.forEach((element: any) => {
						element.style.display = 'none';
					});
				} else if (
					this.show_donation_details == true &&
					this.end_date != '9999-12-31'
				) {
					apreviewAmountRaised.forEach((element: any) => {
						element.style.display = 'flex';
					});
					apreviewProgressInfo.forEach((element: any) => {
						element.style.justifyContent = 'space-between';
					});
				} else if (
					this.show_donation_details == false &&
					this.end_date != '9999-12-31'
				) {
					apreviewProgressInfo.forEach((element: any) => {
						element.style.justifyContent = 'end';
					});
				}

				if (this.show_donation_details == false && this.amount_target == 0) {
					apreviewAmountRaised.forEach((element: any) => {
						element.style.display = 'none';
					});
				} else if (
					this.show_donation_details == false &&
					this.amount_target > 0
				) {
					apreviewAmountRaised.forEach((element: any) => {
						element.style.display = 'inherit';
					});
				}

				let background_image = data.data.result.background.image;
				let background_video = data.data.result.background.video;

				let background;
				if (background_video == '' || background_video == undefined) {
					background =
						background_image ||
						'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/production/fundraiser_header/default/public';
				} else {
					background = this.checkVideoUrl(background_video);
				}

				if (selectBackgroundImageWidget) {
  					selectBackgroundImageWidget.src = background;
				}

				if (formImageBackground) {
	                formImageBackground.src = background || '';
                }

				this.showMainImage();
			});

		this.donationService
			.getDonationWpConfigurationOfFundraiser(
				this.fundraiser_list[this.selectedFundraiser].slug,
				this.fundraiser_list[this.selectedFundraiser].currency_code,
				this.shortcode
			)
			.subscribe((res: any) => {
				this.currencySymbol = res?.data?.symbol;
				this.currencyMinAmount = parseInt(
					res?.data?.customdonationconfiguration?.min_donation_amount
				);
				this.currencyMaxAmount = parseInt(
					res?.data?.customdonationconfiguration?.max_donation_amount
				);
				this.valueChangeFirstAmount =
					res?.data?.customdonationconfiguration?.onetime?.default_1;
				this.valueChangeSecondAmount =
					res?.data?.customdonationconfiguration?.onetime?.default_2;
				this.valueChangeThirdAmount =
					res?.data?.customdonationconfiguration?.onetime?.default_3;
				this.valueChangeFourthAmount =
					res?.data?.customdonationconfiguration?.onetime?.default_4;
				this.valueChangeFifthAmount =
					res?.data?.customdonationconfiguration?.onetime?.default_5;

				this.valueChangeFirstAmountMonthly =
					res?.data?.customdonationconfiguration?.monthly?.default_1;
				this.valueChangeSecondAmountMonthly =
					res?.data?.customdonationconfiguration?.monthly?.default_2;
				this.valueChangeThirdAmountMonthly =
					res?.data?.customdonationconfiguration?.monthly?.default_3;
				this.valueChangeFourthAmountMonthly =
					res?.data?.customdonationconfiguration?.monthly?.default_4;
				this.valueChangeFifthAmountMonthly =
					res?.data?.customdonationconfiguration?.monthly?.default_5;

				this.valueChangeFirstAmountYearly =
					res?.data?.customdonationconfiguration?.yearly?.default_1;
				this.valueChangeSecondAmountYearly =
					res?.data?.customdonationconfiguration?.yearly?.default_2;
				this.valueChangeThirdAmountYearly =
					res?.data?.customdonationconfiguration?.yearly?.default_3;
				this.valueChangeFourthAmountYearly =
					res?.data?.customdonationconfiguration?.yearly?.default_4;
				this.valueChangeFifthAmountYearly =
					res?.data?.customdonationconfiguration?.yearly?.default_5;

				this.currencyCode = res?.data?.currency;

				this.changeFirstAmount();
				this.changeSecondAmount();
				this.changeThirdAmount();
				this.changeForthAmount();
				this.changeFifthAmount();
				let currency_symbol_elements =
					document.querySelectorAll('.currency-symbol');
				currency_symbol_elements.forEach((element) => {
					element.innerHTML =
						this.currencySymbol == undefined ? '€' : this.currencySymbol;
				});
			});
	}

	generateWidgetHTML(shortcode: any) {
		var html = '';
		html += '<div>';
		html += '    <div';
		html += `        id="widget-here-${shortcode}"`;
		html += '        class="widget-here"';
		html += '        data-shortcode="' + shortcode + '"';
		html += '        data-lang="auto"';
		// html += '        data-success_url="' + this.fundraiserSuccessUrl + '""';
		// html += '        data-fail_url="' + this.fundraiserFailUrl + '"';
		html += '        value="donation-widget"';
		html += '    ></div>';
		html += '</div>';
		html += '<link';
		html += '    rel="stylesheet"';
		html += '    href="' + this.cssUrl + '"';
		html += '/>';
		html += '<script';
		html += '    src="' + this.scriptUrl + '"';
		html += '    type="text/javascript"';
		html += '></script>';
		return html;
	}

	copyHtmlCode(shortcode: any) {
		// Navigate to the edit path
		// Create a temporary textarea element
		const textarea = document.createElement('textarea');
		textarea.value = this.generateWidgetHTML(shortcode);

		// Append the textarea to the document
		document.body.appendChild(textarea);

		// Select the text in the textarea
		textarea.select();

		// Execute the copy command
		document.execCommand('copy');

		// Remove the temporary textarea
		document.body.removeChild(textarea);
	}

	onMouseDown(shortcode: string) {
		this.buttonStates[shortcode] = true;
	}

	onMouseUp(shortcode: string) {
		this.buttonStates[shortcode] = false;
	}

	change_onetime(e: any) {
		if (
			this.showHideMonthlyChecked == false &&
			this.showHideYearlyChecked == false
		) {
			this.showHideOneTimeChecked = true;
			e.source.checked = true;
			this.notificationService.openNotification(
				$localize`:@@wdiget_styling_interval_selection_error:Error: At least one of the intervals should always be selected.`,
				'',
				'error'
			);
		}
		this.checkDisabledState();
	}

	change_monthly(e: any) {
		if (
			this.showHideOneTimeChecked == false &&
			this.showHideYearlyChecked == false
		) {
			this.showHideMonthlyChecked = true;
			e.source.checked = true;
			this.notificationService.openNotification(
				$localize`:@@wdiget_styling_interval_selection_error:Error: At least one of the intervals should always be selected.`,
				'',
				'error'
			);
		}
		this.checkDisabledState();
	}

	change_yearly(e: any) {
		if (
			this.showHideOneTimeChecked == false &&
			this.showHideMonthlyChecked == false
		) {
			this.showHideYearlyChecked = true;
			e.source.checked = true;
			this.notificationService.openNotification(
				$localize`:@@wdiget_styling_interval_selection_error:Error: At least one of the intervals should always be selected.`,
				'',
				'error'
			);
		}
		this.checkDisabledState();
	}

	save_code() {
		var colorCode = (<HTMLInputElement>(
			document.getElementById('set-color-input-field')
		))?.value;

		var styleName = 'from_frontend'; // Need for wp plugin backwards compatibility

		let fundraiser_success_url = <HTMLInputElement>(
			document.getElementById('fundraiser-success-url')
		);

		let fundraiser_failure_url = <HTMLInputElement>(
			document.getElementById('fundraiser-failure-url')
		);

		// let fundraiser_list_select = <HTMLInputElement>(
		// 	document.getElementById('fundraiser-list-dropdown')
		// );
		// let fundraiser_list_select_index: any = fundraiser_list_select.value;
		// let selected_option =
		// 	self.fundraiser_list[fundraiser_list_select_index];

		let showProgressBar, showRaisedAmount, showEndDate, doNotShowBox;
		if (this.showDonateCard) {
			showProgressBar = 2;
			showRaisedAmount = 3;
			showEndDate = 4;
			doNotShowBox = 0;
		} else {
			showProgressBar = 0;
			showRaisedAmount = 0;
			showEndDate = 0;
			doNotShowBox = 1;
		}

		let widget_update_request = {
			styleId: 9999,
			pluginStyle: 'Custom',
			fundraiserName: this.fundraiser_list[this.selectedFundraiser].title,
			slugName: this.fundraiser_list[this.selectedFundraiser].slug,
			slugId: this.fundraiser_list[this.selectedFundraiser].id,
			shortcode: this.shortcode,

			primaryColor: this.currentPrimaryColor,
			secondaryColor: this.currentSecondaryColor,

			// successUrl: fundraiser_success_url.value,
			// failureUrl: fundraiser_failure_url.value,

			successUrl: '',
			failureUrl: '',

			background_allowed: this.showMainImageChecked ? 1 : 0,

			styleName: styleName,

			// this.oneTimeCheck = oneCheck ? 1 : 0;
			// this.monthlyCheck = monthCheck ? 2 : 0;
			// this.yearlyCheck = yearCheck ? 3 : 0;

			oneTimeCheck: this.showHideOneTimeChecked ? 1 : 0,
			monthlyCheck: this.showHideMonthlyChecked ? 2 : 0,
			yearlyCheck: this.showHideYearlyChecked ? 3 : 0,

			// firstAmountCheck: firstCheck,
			// secondAmountCheck: secondCheck,
			// thirdAmountCheck: thirdCheck,
			// forthAmountCheck: forthCheck,

			firstAmountCheck: 1,
			secondAmountCheck: 2,
			thirdAmountCheck: 3,
			forthAmountCheck: 4,

			firstAmount: this.valueChangeFirstAmount,
			secondAmount: this.valueChangeSecondAmount,
			thirdAmount: this.valueChangeThirdAmount,
			forthAmount: this.valueChangeFourthAmount,
			fifthAmount: this.valueChangeFifthAmount,

			firstAmountMonthly: this.valueChangeFirstAmountMonthly,
			secondAmountMonthly: this.valueChangeSecondAmountMonthly,
			thirdAmountMonthly: this.valueChangeThirdAmountMonthly,
			fourthAmountMonthly: this.valueChangeFourthAmountMonthly,
			fifthAmountMonthly: this.valueChangeFifthAmountMonthly,

			firstAmountYearly: this.valueChangeFirstAmountYearly,
			secondAmountYearly: this.valueChangeSecondAmountYearly,
			thirdAmountYearly: this.valueChangeThirdAmountYearly,
			fourthAmountYearly: this.valueChangeFourthAmountYearly,
			fifthAmountYearly: this.valueChangeFifthAmountYearly,

			otherChecked: this.showAmountOtherChecked == true ? 1 : 0,

			// showDonateButton: showDonateButton,
			// showProgressBar: showProgressBar,
			// showRaisedAmount: showRaisedAmount,
			// showEndDate: showEndDate,

			showDonateButton: 1,
			showProgressBar: showProgressBar,
			showRaisedAmount: showRaisedAmount,
			showEndDate: showEndDate,

			// doNotShowBox: boxNotShow,
			doNotShowBox: doNotShowBox,

			// showDonationFormOnly: showDonationFormOnlyChecked showDonateForm,
			showDonationFormOnly: this.showDonationFormOnlyChecked == true ? 1 : 0,

			colorCode: colorCode,
			font: this.widgetFontName,
			buttonRadius: this.currentButtonRadius,
			donationTitle: '',

			open_amount: this.onetimeOpenAmountChecked == false ? 0 : 1,
			open_amount_monthly: this.monthlyOpenAmountChecked == false ? 0 : 1,
			open_amount_yearly: this.yearlyOpenAmountChecked == false ? 0 : 1,
			card_shadow: this.boxShadowNumber,
		};

		this.fundraiserService
			.updateWidgetStyleByApiKey(this.api_key, widget_update_request)
			.subscribe((res: any) => {
				this.router.navigate(['/fundraising/widget']);
			});
	}
}
